import { api } from './api';

export interface UserSignature {
  messageSignature: string;
  imageUrl?: string | null;
}

class UserSignatureService {
  async get(): Promise<UserSignature> {
    const response = await api.get<UserSignature>('/support/user-signature');
    return response.data;
  }

  async update(messageSignature: string, image?: File | null, removeImage = false): Promise<UserSignature> {
    const formData = new FormData();
    formData.append('messageSignature', messageSignature);
    formData.append('removeImage', String(removeImage));

    if (image)
    {
      formData.append('image', image);
    }

    const response = await api.put<UserSignature>('/support/user-signature', formData);
    return response.data;
  }
}

export const userSignatureService = new UserSignatureService();
